import calc from "../assets/images/calc.svg";
import clock from "../assets/images/clock.svg";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useState, useEffect } from "react";
import { addComma, gregorianToJalali, setTime } from "../lib/helperFunctions";
import moment from "jalali-moment";
import { DataContext } from "../index";

function CoinTable() {
  const dataContext = useContext(DataContext);
  const [showCal, setShowCal] = dataContext.showCalc;
  const coinPrice = dataContext.coinPrice;
  const updatedAt = gregorianToJalali(coinPrice[0].updatedAt);

  const [coinUpdatedAt, setCoinUpdatedAt] = useState();

  // console.log(
  //   "coinUpdatedAt",
  //   `${process.env.REACT_APP_URL}/api/getUpdateAtCoin`
  // );
  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/getUpdateAtCoin`, {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          return new Error(`error ${response.status} occured...`);
        }
        return response.json();
      })
      .then((res) => {
        // console.log(
        //   "reeeeeeeeeeeeeees",
        //   moment(res.updatedAt, "YYYY-MM-DDTHH:mm:ss.SSZ ").format(
        //     "jYYYY/jM/jD HH:mm z"
        //   )
        // );
        setCoinUpdatedAt(
          moment(res.updatedAt, "YYYY-MM-DDTHH:mm:ss.SSZ ").format(
            "jYYYY/jM/jD HH:mm:ss z"
          )
        );
      })

      .catch((err) => {
        console.log("errrrrr", err);
      });
  }, [setCoinUpdatedAt]);

  return (
    <>
      <div className="coin-table-container">
        <div className="coin-table-header">
          <div className="table-header-bg-coin"></div>
          <section className="coin-table-label"> نرخ سکه</section>
          <section className="table-status">
            <span className="last-update-label">
              <span> آخرین بروزرسانی </span>
              <span>
                <img src={clock} />
              </span>
            </span>
            <span className="last-update-time">
              {/* <span>
                {new Date(coinPrice[0].updatedAt).toString().split(" ")[4]}
              </span>
              <span>
                {updatedAt.year + "/" + updatedAt.month + "/" + updatedAt.day}
              </span> */}
              <span className="mx-3 screen450:mx-1">
                {coinUpdatedAt?.split(" ")[1]}
              </span>
              <span>{coinUpdatedAt?.split(" ")[0]}</span>
            </span>
            <span
              className="calculator"
              onClick={() => {
                setShowCal(!showCal);
              }}
            >
              <span>ماشین حساب</span>
              <span>
                <img src={calc} />
              </span>
            </span>
          </section>
        </div>
        <table className="coin-table">
          <thead>
            <tr>
              <th></th>
              <th>سکه</th>
              <th>خرید</th>
              <th></th>
              <th>فروش</th>
              <th></th>
            </tr>
          </thead>
          {coinPrice?.map((item, i) => {
            // if(i===0)
            // item=coinPrice[1]
            // if(i===1)
            // item=coinPrice[2]
            // if(i===2)
            // item=coinPrice[3]
            // if(i===3)
            // item=coinPrice[4]
            // if(i===4)
            // item=coinPrice[0]

            const buyPriceStatus =
              Number(item.buyPrice) > Number(item.pBuyPrice);
            const sellPriceStatus =
              Number(item.sellPrice) > Number(item.pSellPrice);
            return (
              <tr>
                <td>
                  <img
                    className={`flag`}
                    src={`/flags/coins/${item["coinId"]}@2x.png`}
                  />
                </td>
                <td className={``}>{item.coin.name}</td>
                <td
                  className={`price ${
                    buyPriceStatus ? `green-price` : `red-price`
                  }`}
                >
                  {addComma(item.buyPrice)}
                </td>
                <td>
                  {buyPriceStatus ? (
                    <FontAwesomeIcon
                      icon={faArrowUp}
                      style={{ color: "green" }}
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faArrowDown}
                      style={{ color: "red" }}
                    />
                  )}
                </td>
                <td
                  className={`price ${
                    sellPriceStatus ? `green-price` : `red-price`
                  }`}
                >
                  {addComma(item.sellPrice)}
                </td>
                <td>
                  {sellPriceStatus ? (
                    <FontAwesomeIcon
                      icon={faArrowUp}
                      style={{ color: "green" }}
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faArrowDown}
                      style={{ color: "red" }}
                    />
                  )}
                </td>
              </tr>
            );
          })}
        </table>
      </div>
    </>
  );
}

export default CoinTable;
